import React from "react";
import { useParams } from "react-router-dom";
import SeoLandingPage from "@/pages/public/SeoLandingPage";
import NotFound from "@/pages/public/NotFound";
import { PRODUCT_PAGES } from "@/data/site";

export default function ProductSubPage() {
  const { sub } = useParams();
  const data = PRODUCT_PAGES[sub];
  if (!data) return <NotFound />;
  return (
    <SeoLandingPage
      data={data}
      category="SENIORCAR"
      showSpecs={!!data.showSpecs}
      crumbs={[{ label: "SENIORCAR", path: "/seniorcar" }, { label: data.title }]}
    />
  );
}
